<template>
  <div class="home">
    <!-- <el-button>首页</el-button> -->
    <div class="content">
      <div class="leftBox">
        <!-- logo&slogen -->
        <div class="logo">
          <img src="../assets/pc/logo.png" alt="" />
        </div>
        <div class="slogen">
          <p>THE ULTIMATE FOOTBALL</p>
          <P>HUB FOR PASSIONATE FANS</P>
        </div>
        <!-- 跳转 -->
        <div class="btn">
          <span class="item" @click="toGooglePlay">
            <img src="../assets/pc/googleplay.png" alt="#" />
            <span>Google Play</span>
          </span>
          <span class="item ml-20" @click="toAppStore">
            <img src="../assets/pc/appstore.png" alt="#" />
            <span>App Store</span>
          </span>
          <div class="mt-20">
            <span class="item" @click="installApk">
              <img src="../assets/pc/android_g.png" alt="#" />
              <span>Android</span>
            </span>
          </div>
        </div>
      </div>
      <!-- app截图 -->
      <img class="picture" src="../assets/pc/phone.png" alt="" />
    </div>

    <!-- 底部 -->
    <div class="footer">
      <a href="mailto:support@Eleven11app.com" target="_blank">CONTACT US</a>
      <span class="line"></span>
      <span @click="skipPage('/termsOfUse')">TERMS OF USE</span>
      <span class="line"></span>
      <span @click="skipPage('/privacyPolicy')">PRIVACY POLICY</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "home",
  metaInfo: {
    title: "Eleven11 - Football News & Live Scores",
    meta: [
      {
        name: "description",
        content:
          "Eleven11, get the latest news, live scores and stats from the best teams and leagues in the world."
      },
      {
        name: "keywords",
        content: "football news, live scores"
      }
    ]
  },
  data() {
    return {};
  },
  methods: {
    isIOS: function() {
      return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    installApk() {
      window.location.replace(
        "https://cdn2.eleven11app.com/arndroid_apk/Eleven_Football_3.0.2.apk"
      );
    },
    toAppStore() {
      if (this.isIOS) {
        window.location.replace(
          `itms-appss://apps.apple.com/cn/app/id6736901305`
        );
      }
    },
    toGooglePlay() {
      window.location.replace(
        "https://play.google.com/store/apps/details?id=com.onesports.global"
      );
    },
    skipPage(path) {
      const routeData = this.$router.resolve({ path });
      window.open(routeData.href, "_blank");
    }
  },
  mounted() {
    document.title = "Eleven11";
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/pc/font.css";
.home {
  height: 100vh;
  background-image: url("../assets/pc/backgroundImg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: white;
  overflow: hidden;
  .content {
    display: flex;
    justify-content: center;
    margin-top: 85px;
    .leftBox {
      margin: 122px 10px 0 0;
      .logo {
        width: 242px;
        height: 66px;
        object-fit: contain;
      }
      .slogen {
        margin-top: 34px;
        font-family: MiSansLatin, MiSansLatin;
        font-weight: 600;
        p {
          font-size: 28px;
        }
      }
      .btn {
        margin-top: 45px;
        .item {
          display: inline-flex;
          height: 52px;
          box-sizing: border-box;
          border: 1px solid #ffffff;
          padding: 0 24px;
          align-items: center;
          border-radius: 26px;
          cursor: pointer;
          img {
            width: 28px;
            height: 28px;
          }
          span {
            font-size: 20px;
            font-family: MiSansLatin, MiSansLatin;
            font-weight: 600;
            margin-left: 12px;
          }
        }
        .item:hover {
          border-color: #ff1200;
          background-color: #ff1200;
        }
        .ml-20 {
          margin-left: 20px;
        }
        .mt-20 {
          margin-top: 20px;
        }
      }
    }
    .picture {
      width: 610px;
      height: 620px;
      object-fit: contain;
    }
  }
  .footer {
    width: 100%;
    font-family: MiSansLatin, MiSansLatin;
    font-weight: 400;
    font-size: 14px;
    position: fixed;
    bottom: 61px;
    text-align: center;
    span {
      cursor: pointer;
    }
    .line {
      display: inline-block;
      width: 1px;
      height: 11px;
      background-color: white;
      margin: 0 16px;
    }
    a {
      color: white;
    }
  }
}
</style>
